import {assetContainers} from "./assetsManager" 

const optimizer = (scene, engine) => {
 
// Note: DoNotHandleContextLost optimization done during engine creation
    const meshOptimizations= (meshes) => {
      for(let i = 0; i < meshes.length; i++) {
        if(meshes[i].material && typeof meshes[i].material.freeze === "function") {
         meshes[i].material.freeze();
        }

        if(meshes[i]) {           
          meshes[i].alwaysSelectAsActiveMesh = true
        }

        if(typeof meshes[i].freezeWorldMatrix === "function") {
          if(meshes[i].id !== "crosshair") {
          meshes[i].freezeWorldMatrix();
          }
        }
      }
    }


    var options = new BABYLON.SceneOptimizerOptions.HighDegradationAllowed();

  if (engine) {
    engine.enableOfflineSupport = false;
    engine.setHardwareScalingLevel(1);

  }
 
  options.targetFrameRate = 30;
  
    
  scene.cleanCachedTextureBuffer();

  let allMeshes = [...scene.meshes, ...assetContainers.flat.container.meshes, ...assetContainers.warehouse.container.meshes, ...assetContainers.bunker.container.meshes ]

 //meshOptimizations(allMeshes)

  //scene.freezeActiveMeshes();
  
  BABYLON.SceneOptimizer.OptimizeAsync(
    scene,
    options,
    function () {
      console.log("fps reached");
    },
    function () {
      console.log("fps not reached");

    }
  );
};

export { optimizer };